/**
 * rpgCharacters — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const rpgCharactersPack: ToilePack = {
    slug: 'rpg-characters',
    category: 'rpg',
    name: 'RPG characters',
    tagline: tagline('characters', 'characters', 'art styles'),
    chips: chips('characters', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'tiefling', label: 'Tiefling bard', subject: 'a tiefling bard, curved horns, a lute, velvet doublet'},
        {key: 'dwarf', label: 'Dwarf artificer', subject: 'a dwarf artificer, brass goggles, a clockwork arm'},
        {key: 'elf', label: 'Elven ranger', subject: 'an elven ranger, silver hair, hooded cloak, longbow'},
    ],
    styles: [
        {key: 'oil', label: 'Oil painting', style: 'dramatic oil-painting portrait, half length', palette: 'chiaroscuro, warm single light', framing: 'half length, dark background'},
        {key: 'inkwash', label: 'Ink & wash', style: 'ink and watercolor sketch, loose linework', palette: 'wet washes on white paper', framing: 'loose sketch, concept-art feel'},
        {key: 'sheet', label: 'Character sheet', style: 'full-body character sheet illustration', palette: 'flat grey background', framing: 'full body, three-quarter pose'},
    ],
    directions: ['a halfling rogue instead', 'lit by a single lantern', 'older and battle-worn'],
}
